var map = {
	"./buydypItems/chainge.jpg": 75646,
	"./buydypItems/coin98.png": 24273,
	"./buydypItems/coin98.svg": 53063,
	"./buydypItems/coinbase.png": 77789,
	"./buydypItems/coinbase.svg": 17867,
	"./buydypItems/gate.png": 75656,
	"./buydypItems/glider2@2x.png": 54038,
	"./buydypItems/kucoin.png": 50966,
	"./buydypItems/metamask.png": 25278,
	"./buydypItems/metamask.svg": 9800,
	"./buydypItems/pancake.png": 55624,
	"./buydypItems/pangolin.png": 69961,
	"./buydypItems/safepal.png": 32055,
	"./buydypItems/safepal.svg": 44119,
	"./buydypItems/trustwallet.png": 54784,
	"./buydypItems/trustwallet.svg": 58644,
	"./buydypItems/uniswap.png": 24430,
	"./chainge copy.jpg": 98231,
	"./chainge.jpg": 29210,
	"./clockIcon.svg": 14752,
	"./coin98.png": 82901,
	"./coinbase.png": 80057,
	"./commingSoon.svg": 12236,
	"./dummyVideo.png": 20184,
	"./gateio.png": 16392,
	"./glider2@2x.png": 23562,
	"./huobi.png": 95618,
	"./kucoin.png": 73010,
	"./kyber.png": 28274,
	"./mexc.png": 66104,
	"./noVideo.svg": 20947,
	"./oneinch.png": 15761,
	"./pancake.png": 39588,
	"./pangolin.png": 15253,
	"./poloniex.png": 61097,
	"./traderjoe.webp": 29917,
	"./uniswap.png": 85010,
	"./vendorCardBackground.png": 833,
	"./vids/chainge.jpg": 29147,
	"./vids/coin1.png": 85236,
	"./vids/coin2.png": 7695,
	"./vids/coinavax.png": 95715,
	"./vids/coinbase.png": 86802,
	"./vids/coinbsc.png": 16661,
	"./vids/coineth.png": 50508,
	"./vids/gate.png": 60839,
	"./vids/glider2@2x.png": 89,
	"./vids/inch1.png": 34441,
	"./vids/inch2.png": 69298,
	"./vids/inch3.png": 18299,
	"./vids/kucoin.png": 45093,
	"./vids/kyberdmm.png": 83965,
	"./vids/pan1.png": 6456,
	"./vids/pan2.png": 52211,
	"./vids/panc1.png": 56841,
	"./vids/panc2.png": 42226,
	"./vids/safe1.png": 86764,
	"./vids/safe2.png": 55239,
	"./vids/trust1.png": 68109,
	"./vids/trust2.png": 36342,
	"./vids/uni1.png": 97717,
	"./vids/uni2.png": 11966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8649;